import React from 'react';
import './style.scss';

export const MarketingCardSection = (props) => {

    return (

        <div className="marketing-container">
            <div className="marketing-container-inner">
            <div className="leftSection">
                <img src={props.image} />
            </div>
            <div className="rightSection_">
                    <div className="title">
                        {props.title}
                    </div>
                <div className="description">
                    {props.description}
                </div>
            </div>
            </div>

        </div>
    );
};
